import axios from 'axios'
import * as types from '../mutation-types'
import tagsServices from '../services/tags.js'

// state
export const state = {
  tags: [],
  myTagsTotal: 0,
  popularTags: [],
  myTags: [],
  newPopularTag: null
}

// getters
export const getters = {
  tags: state => state.tags,
  popularTags: state => state.tags.filter(item => Boolean(item.is_popular)),
  selectedTags: state => state.tags.filter(item => item.selected),
  getNewPopularTag: state => state.newPopularTag
}

// mutation
export const mutations = {
  [types.FETCH_TAGS_SUCCESS] (state, { tags, myTagsTotal }) {
    state.tags = tags
    state.myTagsTotal = myTagsTotal
  },
  [types.TOGGLE_SELECTED_TAG_ITEM] (state, { id, value }) {
    const findIndex = state.tags.findIndex(item => item.id === id)
    state.tags[findIndex].selected = value
  },
  [types.SET_TAGS_POPULAR_TAGS] (state, { popularTags }) {
    state.popularTags = popularTags
  },
  [types.SET_TAGS_MY_TAGS] (state, { myTags }) {
    state.myTags = myTags
  }
}

// actions
export const actions = {

  // Fetch Popular Tags
  async fetchPopularTags ({ commit }, params = {}) {
    try {
      const { data } = await tagsServices.fetchPopularTags(params)

      commit(types.SET_TAGS_POPULAR_TAGS, {
        popularTags: data
      })
      return true
    } catch (error) {
      if (axios.isCancel(error) || error.message === 'canceled' || error.name === 'CanceledError') {
        return 'canceled'
      }
      console.error('Error fetching tags:', error)
      return 'error'
    }
  },

  // Fetch my tags
  async fetchMyTags ({ commit }) {
    const { data } = await tagsServices.fetchMyTags()
    try {
      commit(types.SET_TAGS_MY_TAGS, {
        myTags: data
      })
    } catch (error) {
      console.log(error)
    }
  },

  // Add Product to my Tags
  async addProductToMyTags ({ commit }, productIds) {
    await tagsServices.addProductToMyTags({ product_ids: productIds })
  },

  // Remove Product From My Tags
  async removeProductFromMyTags ({ commit }, data) {
    const payload = {
      data: { product_ids: data.productIds }
    }
    await tagsServices.removeProductFromMyTags(payload)
  },

  // Clear My Tags
  async clearMyTags ({ commit }) {
    const payload = {
      data: {
        delete_all: 1
      }
    }
    await tagsServices.removeProductFromMyTags(payload)
  },

  // Remove Product From Popular Tags
  async removeProductFromPopularTag ({ commit }, popularTag) {
    const payload = {
      data: {
        product_ids: popularTag.productIds,
        popular_tag_id: popularTag.popularTagId
      }
    }
    await tagsServices.removeProductFromPopularTag(payload)
  },

  // Create Popular Tags
  async createPopularTag ({ commit }, payload) {
    const { data } = await tagsServices.createPopularTag(payload)
    state.newPopularTag = data?.data
  },

  //  Create Popular Tags HAs Product
  async createPopularTagHasProduct ({ commit }, payload) {
    await tagsServices.createPopularTagHasProduct(payload)
  },

  //  Delete Popular Tag
  async deletePopularTag ({ commit }, payload) {
    await tagsServices.deletePopularTag(payload)
  },

  //  Update Popular Tag
  async updatePopularTag ({ commit }, { id, payload }) {
    await tagsServices.updatePopularTag(id, payload)
  },

  async updateReorderPopularTags ({ commit }, payload) {
    await tagsServices.updateReorderPopularTags(payload)
  },

  // Add Product to Tags by Design Number
  async addProductToTagByDesignNumber ({ commit }, payload) {
    try {
      const response = await tagsServices.addProductToTagByDesignNumber(payload)
      if (response.data.success) {
        return { success: true, data: response.data }
      }
      return { success: false, error: response.data.message }
    } catch (error) {
      return {
        success: false,
        error: error.response?.data?.message || 'Not Found',
        status: error.response?.status
      }
    }
  }

  // if (this.checkedPopularTagItems.length > 0 && this.taggedProducts.length > 0) {
  //   await axios.delete('/api/tag/delete-popular-tag-has-product', {
  //     data: {
  //       popular_tag_ids: this.checkedPopularTagItems.map(item => item.id).join(','),
  //       product_ids: this.taggedProducts.map(item => item.id).join(',')
  //     }
  //   })
}

export default {
  state,
  getters,
  actions,
  mutations
}
